var render = function render(){
  var _vm$content$habilidad;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_vm.visible ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-pencil")]), _vm._v(" " + _vm._s(_vm.edit ? "Editar" : "Cadastrar") + " Unidade Temática ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Unidade Temática*",
      "counter": "100",
      "maxlength": "100",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }, function (v) {
        return _vm.$max(v, 100);
      }]
    },
    model: {
      value: _vm.content.nome,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nome", $$v);
      },
      expression: "content.nome"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Código da Habilidade*",
      "outlined": "",
      "dense": "",
      "multiple": "",
      "item-text": "codigo",
      "item-value": "id",
      "return-object": "",
      "hide-details": "auto",
      "items": _vm.form.lists.listHabilidades,
      "rules": [function (p) {
        return p.some(function (v) {
          return _vm.$required(v);
        }) || 'Campo obrigatório';
      }]
    },
    model: {
      value: _vm.content.habilidades,
      callback: function ($$v) {
        _vm.$set(_vm.content, "habilidades", $$v);
      },
      expression: "content.habilidades"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex mt-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-gesture-double-tap")]), _vm._v(" Habilidade(s) Selecionada(s)")], 1), _c('v-chip-group', {
    attrs: {
      "active-class": "primary--text",
      "column": ""
    }
  }, _vm._l(_vm.content.habilidades, function (habilidade, i) {
    return _c('v-chip', {
      key: i,
      on: {
        "click": function ($event) {
          return _vm.selecionarChip(habilidade);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-checkbox-marked-circle-outline")]), _vm._v(" " + _vm._s(habilidade.codigo) + " ")], 1);
  }), 1), _vm.descricaoHabilidadeSelecionada && (_vm$content$habilidad = _vm.content.habilidades) !== null && _vm$content$habilidad !== void 0 && _vm$content$habilidad.length ? _c('span', [_c('span', {
    staticClass: "small"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-alert-circle-check-outline")]), _vm._v(" Informações da Habilidade Selecionada")], 1), _c('v-chip-group', {
    attrs: {
      "column": ""
    }
  }, [_c('v-chip', [_vm._v(_vm._s(_vm.descricaoHabilidadeSelecionada))])], 1)], 1) : _vm._e()], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "O que será avaliado*",
      "maxlength": "2500",
      "counter": "2500",
      "rows": "4",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }, function (v) {
        return _vm.$max(v, 2500);
      }]
    },
    model: {
      value: _vm.content.descricao,
      callback: function ($$v) {
        _vm.$set(_vm.content, "descricao", $$v);
      },
      expression: "content.descricao"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "mt-4"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("mdi-alert-circle")]), _c('span', [_vm._v("Os campos marcados com asterisco(*) são obrigatórios.")])], 1)], 1), _c('sca-buttons', {
    attrs: {
      "actionText": _vm.edit ? 'Editar' : 'Salvar'
    },
    on: {
      "click": function ($event) {
        return _vm.salvar();
      },
      "cancel": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  })], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }